import Phaser from 'phaser';
import {gsap} from 'gsap';

import Confetti from './confetti';



export default class ClearScr{

    constructor(){
        GAME_REF.obj.clear = this;
        this.scene = GAME_REF.scene;
        this.manager = GAME_REF.obj.manager;

        this.isConfetti = true;
        this.scores = [];

        this.timer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    _init(){
        this._create();
        this._anime();
        GAME_REF.obj.sound.playOne('na_yey');

        this.timer = gsap.delayedCall(5, ()=>{
            window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
            window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
            this.timer = null;
            this.scene.nextScene();
        });

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    _create(){
        this.overlay = this.scene.add.graphics();
        this.overlay.fillStyle(0x84DBA7);
        this.overlay.fillRect(0, 0, 1280, 775);

        this.light = this.scene.add.image(640, 375, 'clear_light');

        this.dragon1 = this.scene.add.image(640, 375, 'clear_dragon1');
        this.dragon2 = this.scene.add.image(640, 375, 'clear_dragon2'); 
        

        this.shimajiro = this.scene.add.image(640, 600, 'clear_shimajiro');
        this.shimajiro.alpha = 0;

        this.score = this.scene.add.container(0, 56);
        this.score.alpha = 0;
        this.score.setScale(1.1);
        this.score_text = this.scene.add.image(0, 0, 'clear_score');
        this.score_text.setOrigin(0, 0);
        this.score.add(this.score_text);

        const score_str = this.scene.score.toString();
        const ary = score_str.split('').map(Number);
        for(let i=0; i<ary.length; i++){
            const x = i * 116 + this.score_text.width;
            const num = this.scene.add.sprite(x, 0, 'clear_score_number');
            num.setOrigin(0, 0);
            num.setFrame(ary[i]);
            this.score.add(num);
        }

        this.score.x = 640 - this.score.getBounds().width/2;
        
        this.confetti = new Confetti();
        this._tick();
    }

    _anime(){

        // 背景のクルクル
        this.lightTween = this.scene.tweens.add({
            targets: this.light,
            angle: 20,
            ease: 'Linear',
            duration: 1000, 
        });

        // しまじろー
        this.scene.tweens.add({
            targets: this.shimajiro,
            y: 600,
            alpha: 1,
            duration: 400,
            delay: 500,
            ease: 'Back.easeOut'
        });
        this.scene.tweens.add({
            targets: this.shimajiro,
            scaleY: 0.99,
            duration: 400,
            ease: 'Sine.easeInOut',
            yoyo: true, 
            repeat: -1
        });

        // スコア
        this.scene.tweens.add({
            targets: this.score,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 500,
            delay: 650,
            ease: 'Cubic.easeOut'
        });

        // ドラゴン
        this._setDragonAnime(this.dragon1, 400);
        this._setDragonAnime(this.dragon2, 600);
    }

    _setDragonAnime(_target, _delay){
        _target.setScale(0.7);
        _target.alpha = 0;

        this.scene.tweens.add({
            targets: _target,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            duration: 900,
            delay: _delay,
            ease: 'Cubic.easeOut'
        });
    }


    _tick(){
        if(!this.isConfetti) return;

        this.confetti.update();
        requestAnimationFrame(this._tick.bind(this));
    }


    _pause(){
        if(this.timer) this.timer.pause();
    }

    _resume(){
        if(this.timer) this.timer.resume();
    }
}